import { profileConstants,financialInfoConstants} from "../_constants";
import { history } from "../_helpers";
import { ProfileApi, UserBasisApi, userService, SessionService, UserSession, FinancialService, ProfileService } from "../_services";
import { userActions } from "./user.actions";

export const profileActions = {
    loadProfile, 
    editProfile, 
    saveExtendedProfile,
    saveExtendedUserProfile,
    saveToggleSelectedLanguage,
};

function loadProfile(){
    return dispatch => {
        dispatch(loadProfileStart());
        return ProfileApi.getExtendedProfileInfo()
            .then(response => 
              {
                  if(response.data){
                      const session = ProfileService.loadExtendedProfileInfoInSession(response.data)
                      dispatch(loadProfileSuccess(session))
                      dispatch(userActions.setAppLanguage(response.data.selectedLanguage));
                      dispatch(loadFianancials(session.employers,session.incomes));
                    }
                }).catch(error => failure(error))
            };
    function loadProfileSuccess(session) {
      return {
        type: profileConstants.LOAD_PROFILE_SUCCESS,
        profile: {
          ...session.personalInfo,
          employers: session.employers,
          incomes : session.incomes,
          branchId: session.branchId,  
        },
      };
    }   
    function loadProfileStart() {
        return { type: profileConstants.LOAD_PROFILE_START };
    }   
    function failure(errorString) {
        return { type: profileConstants.GENERIC_FAILURE, errorString };
    }
    function loadFianancials(employers, incomes) {
      return {
        type: financialInfoConstants.LOAD_FINANCIALS_FROM_SESSION_SUCCESS,
        employers,
        incomes,
      };
    }
}

function saveExtendedProfile(newProfile, newResidentialBasis){
    return dispatch => {
        return ProfileApi.saveExtendedUserProfile(newProfile)
            .then(response => {
                let currentUser = userService.getCurrentUser();
                let residentialBasis = {
                    UserId: currentUser.user.userId,
                    UserHash: currentUser.userHash,
                    MonthsAtResidence: newResidentialBasis.monthsInHome,
                    YearsAtResidence: newResidentialBasis.yearsInHome,
                    OwnResidence: newResidentialBasis.rentOrOwn === 1,
                    MonthlyResidencePayment: newResidentialBasis.monthlyResidencePayment
                };

                UserBasisApi.saveResidentialBasis(residentialBasis)
                    .then(residentialBasisResponse => dispatch(saveExtendedProfileSuccess(response)));
            });
    }

    function saveExtendedProfileSuccess(response){
            return {type: profileConstants.SAVE_ADDRESS_SUCCESS, }
    }
    function saveResidentialBasisSuccess(response) {
        return { type: profileConstants.SAVE_RESIDENTIAL_BASIS_SUCCESS, }
    }
}
function editProfile(editedProfile){
    return dispatch => {
        return dispatch({type: profileConstants.EDIT_PROFILE_UPDATE, profile: editedProfile})
    }
}


function saveExtendedUserProfile(extendedUserProfile){
    return dispatch => {
        dispatch(saveExtendedUserProfileStart())
        return ProfileApi.saveExtendedUserProfile(extendedUserProfile)
            .then(response => {
              dispatch(success());  
              dispatch(loadProfile());
            });
    }
    function saveExtendedUserProfileStart() {
        return { type: profileConstants.SAVE_EXTENDED_PROFILE_START };
    } 
    function success() {
        return { type: profileConstants.SAVE_EXTENDED_PROFILE_SUCCESS };
    } 
}

function saveToggleSelectedLanguage() {
  return (dispatch) => {
    dispatch(saveExtendedUserProfileStart());
    const profile = SessionService.getPersonalInfo();
    const selectedLanguage = String(profile.selectedLanguage).toUpperCase() ===
    userService.LANGUAGES.EN
      ? userService.LANGUAGES.ES
      : userService.LANGUAGES.EN;
    return ProfileApi.saveExtendedUserProfile({
      ...profile,
      saveMobile: false,
      saveAddress: false,
      employers: null, // to force not saving
      incomes: null, // to force not saving
      selectedLanguage,
    }).then((response) => {
      SessionService.setPersonalInfo({...profile,selectedLanguage});
      dispatch(success(selectedLanguage));
    });
  };
  function saveExtendedUserProfileStart() {
    return { type: profileConstants.SAVE_EXTENDED_PROFILE_START };
  }
  function success(selectedLanguage) {
    return { type: profileConstants.SAVE_EXTENDED_PROFILE_SUCCESS,selectedLanguage };
  }
}